import "scripts/templates/page.faq.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.faq");
